import '../styles/talento.scss';
import initPageChrome from './page-chrome';

document.addEventListener('DOMContentLoaded', initPageChrome);
